<template>
    <span class="in-line">
        <span v-if="readOnly">
            {{labelString}}
        </span>
        <span  v-on:click="toggleEditable" class="mr-2 cursor-pointer" v-if="!editable && !readOnly" title="Click per editare">
            {{labelString}}
        </span>
        <input type="text" ref="inputLabel" :value="label" placeholder="Inserisci etichetta..." class="form-control form-control-sm w-auto d-inline mr-2" v-if="editable" @blur="saveValue" />
        <!--<a v-on:click="saveValue" v-if="editable" class="text-info mr-2">
            <font-awesome-icon icon="save"></font-awesome-icon>
        </a>
        <a v-on:click="toggleEditable" v-if="editable" class="text-danger">
            <font-awesome-icon icon="times"></font-awesome-icon>
        </a>-->
    </span>
    
</template>
<style>
    .cursor-pointer{
  cursor: pointer;
}
</style>
<script>

export default {
        name: 'editableLabel',
       
        props: {
            label: {
                type: String,
                required: false
            },
            index: {
                type: Number,
                required: false
            },
            defaultLabel: {
                type: String,
                required: false
            },
            readOnly: {
                type: Boolean,
                required: false,
                  default:()=> false
            }
        },
        computed: {
            labelString() {
             
                if (this.label == '' || !this.label) {
                    return this.defaultLabel + " " + (this.index > 0 ? (this.index + 1).toString() : "");
                }
                else return this.label;
            }

        },
        components: {
           
        },
        data() {
            return {
                editable: false
            };
        },
        methods: {
            toggleEditable: function () {
               
                this.editable = !this.editable;
                let me = this;
                setTimeout(function () {
                    if (me.editable) {
                        me.$refs.inputLabel.focus();
                    }
                }, 200);
                

            },
            updateValue: function (v) {
                let value = this.label;
                value = v;
              
                this.$emit('update-label', value)
            },
            saveValue: function () {
                this.updateValue(this.$refs.inputLabel.value);
                this.toggleEditable();

            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
